<template>
  <div>
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-width="140px"
      :hide-required-asterisk="false"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="姓名：" prop="ygbh" key="2">
            <treeselect
              placeholder="请选择员工"
              :options="deptUser"
              :disable-branch-nodes="true"
              :show-count="true"
              value-consists-of="LEAF_PRIORITY"
              no-results-text="未搜到任何结果"
              :clear-on-select="true"
              :normalizer="normalizer"
              style="width: 100%"
              size="small"
              @input="getYgInfo"
              v-model="form.ygbh"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="性别：" prop="sex" key="2">
            <el-radio-group v-model="form.sex" disabled>
              <el-radio label="M">男 </el-radio>
              <el-radio label="W">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="出生日期：" prop="sex" key="2">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
              :clearable="false"
              disabled
              v-model="form.birthday"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="职称职务：" prop="sex" key="2">
            <el-input
              show-word-limit
              placeholder="请输入职称职务"
              maxlength="100"
              disabled
              v-model="form.post"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工作单位：" prop="sex" key="2">
            <el-input
              show-word-limit
              placeholder="请输入工作单位"
              maxlength="100"
              disabled
              v-model="form.workPlace"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系电话：" prop="sex" key="2">
            <el-input
              show-word-limit
              placeholder="请输入联系电话"
              maxlength="100"
              disabled
              v-model="form.phone"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="课题承担任务：" prop="courseMission" key="2">
            <el-input
              show-word-limit
              placeholder="请输入课题承担任务"
              maxlength="100"
              v-model="form.courseMission"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getMemberByYgbh, saveCourseMember } from "@/api/course.js";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {},
      rules: {
        ygbh: [{ required: true, message: "员工不能为空", trigger: "blur" }],
        courseMission: [
          { required: true, message: "课题承担任务不能为空", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
  },
  methods: {
    getYgInfo(e) {
      getMemberByYgbh({ ygbh: e }).then((res) => {
        if (res.code == 0) {
          this.form = { ...res.data, ygbh: e };
          this.form.birthday = moment(this.form.birthday);
        }
      });
    },
    saveForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const applyId = this.mxParams.aid
            ? this.mxParams.aid
            : this.mxParams.applyId;
          const { memberId, ygbh, courseMission } = this.form;
          saveCourseMember({ memberId, ygbh, applyId, courseMission }).then(
            (res) => {
              if (res.code == 0) {
                this.$message.success(res.msg);
                this.$emit("giveFather");
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
</style>